<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cadastro de Parceiros" posicao="left" />

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir novo parceiro" @click_bt_modal="click_bt_modal" :exibe_botao="true">

      <template #default>
        <form @submit.prevent="cadastrar" enctype="multipart/form-data" id="cad_partner">
          <fieldset>
            <div class="row">
              <InputText placeholder="" label="Nome da empresa *" tamanho="sm" nome="nome_empresa" ref="nome_empresa"
                v-model="dadosEdit.nome_empresa" classDiv="col-md-7" />
              <InputText placeholder="" label="Email da empresa *" tipo="email" tamanho="sm" nome="email" ref="email"
                v-model="dadosEdit.email" classDiv="col-md-5" />

              <div class="col-md-8">
                <InputText placeholder="" label="Banner do parceiro" tipo="file" tamanho="sm" nome="banner" ref="banner"
                  @change="previewBanner" v-model="dadosEdit.img_banner" />
              </div>
              <div class="col-md-4">
                <div class="col-12 text-center">
                  <img :src="imagem_banner" class="img img-fluid img-thumbnail mb-3" id="pre_banner" alt="">
                </div>
              </div>

              <div class="col-md-8">
                <InputText placeholder="" label="Logo do parceiro" tipo="file" tamanho="sm" nome="logo" ref="logo"
                  @change="previewLogo" v-model="dadosEdit.img_file" />
              </div>
              <div class="col-md-4">
                <div class="col-12 text-center">
                  <img :src="imagem_destaque" class="img img-fluid img-thumbnail mb-3" id="pre_logo" alt="">
                </div>
              </div>

              <InputTextMask classDiv="col-md-3" mask="cep" label="CEP" tamanho="sm" nome="cep" ref="cep"
                v-model="dadosEdit.cep" />
              <InputText placeholder="" label="Rua" tamanho="sm" nome="rua" ref="rua" v-model="dadosEdit.rua"
                classDiv="col-8 col-md-6" />
              <InputText placeholder="" label="Número" tamanho="sm" nome="numero" ref="numero"
                v-model="dadosEdit.numero" classDiv="col-4 col-md-3" />
              <InputText placeholder="" label="Bairro" tamanho="sm" nome="bairro" ref="bairro"
                v-model="dadosEdit.bairro" classDiv="col-md-6" />
              <InputText placeholder="" label="Complemento" tamanho="sm" nome="complemento" ref="complemento"
                v-model="dadosEdit.complemento" classDiv="col-md-6" />
              <InputText placeholder="" label="Cidade" tamanho="sm" nome="cidade" ref="cidade"
                v-model="dadosEdit.cidade" classDiv="col-6 col-md-8" />
              <InputSelect classDiv="col-6 col-md-4" :dados="estados_brasil" label="Estado" tamanho="sm" name="estado"
                ref="estado" v-model="dadosEdit.estado" />

              <InputTextMask classDiv="col-md-6" label="Telefone da empresa" tamanho="sm" nome="telefone_empresa"
                ref="telefone_empresa" v-model="dadosEdit.telefone_empresa" />
              <InputTextMask classDiv="col-md-6" label="Whatsapp da empresa" tamanho="sm" nome="whatsapp_empresa"
                ref="whatsapp_empresa" v-model="dadosEdit.whatsapp_empresa" />
              <InputText placeholder="" label="facebook" tamanho="sm" nome="facebook" ref="facebook"
                v-model="dadosEdit.facebook" classDiv="col-6" />
              <InputText placeholder="" label="Instagram" tamanho="sm" nome="instagram" ref="instagram"
                v-model="dadosEdit.instagram" classDiv="col-6" />
              <InputText placeholder="" label="Canal do Youtube" tamanho="sm" nome="canal_youtube" ref="canal_youtube"
                v-model="dadosEdit.canal_youtube" classDiv="col-6" />
              <InputText placeholder="" label="Vídeo do Youtube" tamanho="sm" nome="video_youtube" ref="video_youtube"
                v-model="dadosEdit.video_youtube" classDiv="col-6" />

              <InputText placeholder="" :multiple="true" tipo="file" label="Arquivos para galeria do parceiro"
                tamanho="sm" nome="galeria" ref="galeria" v-model="dadosEdit.galeria" />

              <div class="col-12 p-2 mb-3">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" v-for="(item, index) in galeria" :key="index">
                    <img :src="item.path_full" alt="" class="img-fluid" style="max-height: 60px;">
                    <a class="btn btn-sm btn-danger float-end" @click="exclui_arquivo(item.name)">
                      <i class="bi bi-trash3"></i>
                      Excluir
                    </a>
                  </li>
                </ul>
              </div>

              <InputEditor name="texto_inicial" class="form-control" v-model="dadosEdit.texto_inicial" />

              <InputText placeholder="" label="Nome do responsavel" tamanho="sm" nome="nome_responsavel"
                ref="nome_responsavel" v-model="dadosEdit.nome_responsavel" classDiv="col-6" />
              <InputTextMask classDiv="col-md-6" label="Whatsapp do contato" tamanho="sm" nome="telefone_responsavel"
                ref="telefone_responsavel" v-model="dadosEdit.telefone_responsavel" />

              <input type="submit" class="d-none" value="">
            </div>
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="cadastrar" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        Tem certeza que deseja deletar o Parceiro <strong>"{{ titulo_delete }}"</strong>?
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :btnStatus="true" :btnEdit="true" :btnDelete="true"
      :ativa_placeholder="ativa_placeholder" :columns="colunas" @edit_status="edit_status" @edit_row="dados_editar"
      @delete_row="deletar_dados" modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import TituloGrande from '@/components/TituloGrande.vue'
import Modal from '@/components/Modal.vue';
import InputText from "@/components/form/InputText.vue";
import { toastr } from '@/plugins/toast.js'
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import { estados_brasil } from '@/assets/js/dados_json'
import InputTextMask from '@/components/form/InputTextMask.vue';
import InputSelect from '@/components/form/InputSelect.vue';
import InputEditor from '@/components/form/InputEditor.vue';

import { busca_cep, bloqueia_campos, mensagem_request, preview_img } from '@/assets/js/functions';

export default {
  components: { TituloGrande, TabelaDatatable, Modal, InputText, InputTextMask, InputSelect, InputEditor },
  name: 'CadParceiros',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      titulo_delete: String,
      dadosEdit: {
        // nome_empresa: 'WMATECH',
        // cep: '26020041',
        // rua: 'rua lapinha',
        // numero: '25',
        // bairro: 'kennedy',
        // complemento: 'complemento',
        // cidade: 'cidade',
        // estado: 'RJ',
        // telefone_empresa: '21969966552',
        // whatsapp_empresa: '21845652655',
        // facebook: 'facebook',
        // instagram: 'instagram',
        // canal_youtube: 'canal_youtube',
        // video_youtube: 'video_youtube',
        // texto_inicial: 'texto_inicial',
        // nome_responsavel: 'nome_responsavel',
        // telefone_responsavel: '21789546587',
      },
      // img_data: null,
      imagem_banner: '',
      imagem_destaque: '',
      dadosData: '',
      galeria: null,
      colunas: [
        { data: 'nome_empresa', title: 'Nome da empresa', width: '40%' },
        { data: 'whatsapp_empresa', title: 'Whatsapp da empresa', width: '40%' },
        { data: 'nome_responsavel', title: 'Nome do representante', width: '40%' },
        { data: 'telefone_responsavel', title: 'Telefone do representante', width: '40%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      textoBtnCadastro: 'Cadastro de Parceiro',
      ativa_placeholder: Boolean,
      estados_brasil: estados_brasil()
    }
  },
  mounted() {
    this.listagemTabela();
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.post('partner/list')
      this.ativa_placeholder = false
    },
    async previewBanner(event) {
      var ban = await preview_img(event, "#pre_banner")
    },
    async previewLogo(event) {
      await preview_img(event, "#pre_logo")
    },
    // async preview(event, img_prev) {
    //   var result = ''
    //   var files = ''
    //   // Reference to the DOM input element
    //   var input = event.target;

    //   // Ensure that you have a file before attempting to read it

    //   if (input.files && input.files[0]) {
    //     // create a new FileReader to read this image and convert to base64 format
    //     var reader = await new FileReader();
    //     // Define a callback function to run, when FileReader finishes its job
    //     reader.onload = (e) => {
    //       // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
    //       // Read image as base64 and set to imageData
    //       document.querySelector(img_prev).src = e.target.result;

    //     }
    //     // Start the reader job - read file as a data url (base64 format)
    //     reader.readAsDataURL(input.files[0]);
    //     files = input.files[0]
    //   } else {
    //     files = null;
    //   }
    //   return {
    //     result: result,
    //     files: files
    //   }
    // },
    // previewImage: function (event) {
    //   // Reference to the DOM input element
    //   var input = event.target;
    //   // Ensure that you have a file before attempting to read it

    //   if (input.files && input.files[0]) {
    //     // create a new FileReader to read this image and convert to base64 format
    //     var reader = new FileReader();
    //     // Define a callback function to run, when FileReader finishes its job
    //     reader.onload = (e) => {
    //       // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
    //       // Read image as base64 and set to imageData
    //       this.imagem_destaque = e.target.result;
    //     }
    //     // Start the reader job - read file as a data url (base64 format)
    //     reader.readAsDataURL(input.files[0]);
    //     this.img_data = input.files[0]
    //   } else {
    //     this.img_data = null;
    //   }
    // },
    async cadastrar(e) {
      e.preventDefault();

      if (!this.dadosEdit.nome_empresa) {
        toastr.alerta("Digite o nome da empresa")
        return false;
      }

      const formu = document.querySelector("#cad_partner")

      const dados = new FormData(formu)

      dados.append('texto_inicial', this.dadosEdit.texto_inicial)
      // if (this.img_data) {
      //   dados.append('logo', this.img_data)
      // }

      if (this.id_cat > 0) {
        dados.append('id', this.id_cat)
      }

      bloqueia_campos()
      try {
        const data = await api.post('partner/register', dados, { Authorization: this.auth.token }, false)
        if (data?.status >= 400) {
          for (const key in data.message) {
            toastr.erro(data.message[key]);
          }
        } else if (data?.status == 200) {
          toastr.sucesso(data.message)
          if (!this.id_cat) {
            this.limpa_campos()
          } else {
            this.carrega_galeria(this.id_cat)
            this.dadosEdit.galeria = null;
          }
          this.listagemTabela()
        } else {
          toastr.erro("Erro ao cadastrar o parceiro, tente novamente dentro de alguns minutos.")
        }
      } catch (error) {
        toastr.erro("Erro ao cadastrar.");
      }
      bloqueia_campos(false)
    },
    async edit_status(dados) {
      try {
        var sts = (dados.cellData == 'Ativo' ? 'Inativo' : 'Ativo')
        var id = dados.rowData.id
        var autoriza = await api.autoriza();

        const stat = {
          status: sts,
          id: id,
        }

        if (autoriza) {
          try {
            const data = await api.post('partner/change_status', stat)
            if (data.status == 200) {
              var mgn = `Status de ${dados.rowData.nome_empresa} alterado para ${sts}`;
              if (sts == 'Ativo') {
                toastr.sucesso(mgn)
              } else {
                toastr.alerta(mgn)
              }
              this.listagemTabela()
            } else {
              toastr.erro('Erro ao alterar o status, tente novamente em alguns instantes.')
            }
          } catch (error) {
            toastr.erro('Erro ao se comunicar com a API, tente novamente em alguns instantes.')
          }
        } else {
          toastr.erro("É preciso estar logado como admin para esta ação.")
          this.$router.push('/login')
        }
      } catch (error) {
        toastr.erro("Erro na solicitação, tente novamente em alguns instantes.")
      }
    },
    async dados_editar(dados) {
      bloqueia_campos()
      var dadosEdit = await api.post('partner/list/' + dados.rowData.id)
      this.dadosEdit = dadosEdit
      this.id_cat = dados.rowData.id;

      if (dadosEdit.logo) {
        this.imagem_destaque = "/img/parceiros/" + this.id_cat + "/" + dadosEdit.logo;
      }

      if (dadosEdit.banner) {
        this.imagem_banner = "/img/parceiros/" + this.id_cat + "/" + dadosEdit.banner;
      }

      this.carrega_galeria(dados.rowData.id)

      document.querySelector("#btn_modal_cadastrar").click()
      bloqueia_campos(false)
    },
    async carrega_galeria(parceiro) {
      this.galeria = await api.post('partner/gallery/' + parceiro)
    },
    async exclui_arquivo(file) {
      var nome = file.split('.')
      var ext = nome.pop()
      try {
        var url = 'partner/delete_file/' + this.id_cat + '/' + nome[0] + '/' + ext
        const del = await api.post(url)
        mensagem_request(del)
        if (del.status == 200) {
          this.carrega_galeria(this.id_cat)
        } else {
          console.log(del);
        }
      } catch (error) {
        toastr.erro("Falha na requisição, tente novamente")
      }
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.dadosEdit = {};
      this.id_cat = 0;
      this.img_file = '';
      this.img_banner = '';
      // this.img_data = null;
      this.galeria = null;
      this.imagem_banner = null;
      this.imagem_destaque = null;
      document.querySelectorAll('.img').src
    },
    click_bt_modal() {
      if (this.id_cat > 0) {
        this.textoBtnCadastro = 'Editando parceiro: ' + this.dadosEdit.nome_empresa
      } else {
        this.textoBtnCadastro = 'Cadastro de parceiro'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.nome_empresa
    },
    async deletar() {
      bloqueia_campos()
      var autoriza = await api.autoriza();

      if (autoriza) {
        try {
          var deletar = await api.post('partner/delete/' + this.id_delete)
          if (deletar.status == 200) {
            toastr.sucesso(deletar.message)
            this.listagemTabela()
            document.querySelector("#btn_close_modal_delete").click()
          } else {
            toastr.erro(deletar.message)
          }
        } catch (error) {
          toastr.erro(error)
        }
        bloqueia_campos(false)
      }
    },
    async carrega_endereco(cep) {
      bloqueia_campos()
      var dados_cep = await busca_cep(cep)

      this.dadosEdit.rua = dados_cep.rua;
      this.dadosEdit.bairro = dados_cep.bairro;
      this.dadosEdit.cidade = dados_cep.cidade;
      this.dadosEdit.estado = dados_cep.estado;
      bloqueia_campos(false)
      if (dados_cep.status == 200) {
        document.getElementById('numero').focus()
      } else {
        document.getElementById('cep').focus()
      }
    }
  },
  watch: {
    'dadosEdit.cep'(n, o) {
      if (n != undefined && o != undefined) {
        if (n.length == 9) {
          this.carrega_endereco(n)
        }
      }
    },
  },
}
</script>

<style></style>